export const normalizeGuid = (guid) =>
  typeof guid === 'string' ? guid.toLowerCase() : '';
